(() => {
  const STYLE_TEXT = `
    :host {
      --payment-terms-background-color: transparent;
    }
    #shopify-installments,
    #shopify-installments p,
    #shopify-installments span,
    #shopify-installments a,
    #shopify-installments button,
    .shopify-installments,
    .shopify-installments p,
    .shopify-installments span,
    .shopify-installments a,
    .shopify-installments button,
    .font-sans,
    .font-sans p,
    .font-sans span,
    .font-sans a,
    .font-sans button {
      font-family: commercial, sans-serif !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      letter-spacing: normal !important;
      margin-top: .25rem;
    }
    @media screen and (min-width: 750px) {
      #shopify-installments,
      #shopify-installments p,
      #shopify-installments span,
      #shopify-installments a,
      #shopify-installments button,
      .shopify-installments,
      .shopify-installments p,
      .shopify-installments span,
      .shopify-installments a,
      .shopify-installments button,
      .font-sans,
      .font-sans p,
      .font-sans span,
      .font-sans a,
      .font-sans button {
        font-size: 15px !important;
        margin-top: .25rem;
      }
    }
  `;

  let sheet = null;
  const getSheet = () => {
    if (sheet) return sheet;
    try {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(STYLE_TEXT);
    } catch (e) {
      sheet = null;
    }
    return sheet;
  };

  const applyStyles = (el) => {
    const root = el.shadowRoot;
    if (!root || el.dataset.installmentsStyled === 'true') return;

    const s = getSheet();
    if (s && Array.isArray(root.adoptedStyleSheets)) {
      if (!root.adoptedStyleSheets.includes(s)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, s];
      }
      el.dataset.installmentsStyled = 'true';
    } else if (!root.querySelector('style[data-installments-style]')) {
      // Fallback for browsers without constructable stylesheet support.
      const style = document.createElement('style');
      style.setAttribute('data-installments-style', '');
      style.textContent = STYLE_TEXT;
      root.appendChild(style);
      el.dataset.installmentsStyled = 'true';
    }
  };

  const tryStyle = (el) => {
    if (el.shadowRoot) {
      applyStyles(el);
      return;
    }
    // Poll briefly until Shopify attaches the shadow root, then stop.
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (el.shadowRoot) {
        applyStyles(el);
        clearInterval(timer);
      } else if (tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  };

  const scan = () => {
    document
      .querySelectorAll('.product__shop-installments shopify-payment-terms')
      .forEach(tryStyle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
